import { hasPricesWithoutZeroPenny } from 'init/has-prices-without-zero-penny'
/**
 * Функция для разделения числа на целую и дробную части.
 * @param {string|number} value Значение для приведения к стоимости.
 * @param {string} [separator] Разделитель в числах больше 3-х знаков.
 * @returns {Array} Массив с целой и дробной частями (или пустой, если не удалось привести значение к числу).
 */
export const fractionNumber = (value, separator) => {
  separator = String(separator) === separator ? separator : ' '
  const string = String(value).toLowerCase(),
    number = Number(string)
  let result = [],
    decimals
  if (!isNaN(number)) {
    decimals = (number < 0.01 && number > 0) ? 4 : 2
    result = [
      number.toFixed(2).replace(/\.[^.]*$/g, ''), // убираем все числа после точки и точку
      number.toFixed(decimals).replace(/^.*\./g, ''), // убираем все числа до точки и точку
    ]
    let array = result[0].split(''), // получаем массив строк с цифрами из строки целой части числа
      separated = []
    while (array.length) {
      separated.unshift(array.splice(-3).join('')) // вытаскиваем последние три цифры и объединяем в строку
    }
    result[0] = separated.join(separator) // подменяем целую часть на целую разделённую
  }
  return result
}

/**
 * Метод разделяет числа на целую и дробную части через fractionNumber,
 * после проверяет на '00' дробную часть c последующей очисткой строки, если условие выполняется.
 * @param {string|number} value Значение для приведения к стоимости.
 * @param {string} [separator] Разделитель в числах больше 3-х знаков.
 * @returns {Array} Массив с целой и дробной частями
 * или пустой, если не удалось привести значение к числу,
 * или с одним элементом целой части, если дробная равна '00'
 */
export const numberWithoutZeroFraction = (value, separator) => {
  let result = fractionNumber(value, separator)
  if (hasPricesWithoutZeroPenny && result[1] === '00') {
    result.pop()
  }
  return result
}

/**
 * Метод для округления числа до двух знаков при операциях c числами с плавающей запятой (в частности ценами).
 * @param {number} value
 * @returns {number} округленное число
 */
export const roundFloatPointNum = value => {
  let result = 0
  if (value < 0.01 && value > 0) {
    result = Math.round(value * 10000) / 10000
  } else {
    result = Math.round(value * 100) / 100
  }
  return result
}

/**
 * Добавляет пробел к целому или дробному числу.
 * @param {number} value Значение
 * @returns {string}
 */
export const addSpaceToFloatNumber = value => {
  let numberArray = fractionNumber(value),
    result
  if (Number(numberArray[1].slice(0, 1)) > 0) {
    result = numberArray[0] + '.' + numberArray[1].slice(0, 1)
  } else {
    result = numberArray[0]
  }
  return result
}

/**
 * Определяет, является ли значение числовым ($.isNumeric).
 * @param {*} value Проверяемое значение.
 * @returns {boolean} Значение, является числовым?
 */
export const isNumeric = value => !isNaN(parseFloat(value)) && isFinite(value)

/**
 * Возвращает целое отформатированное цисло с указанной разрядностью.
 * @param {number} value Передаваемое значение.
 * @param {number} size Необходимая разрядность числа.
 * @returns {string} Отформатированное число.
 */
export const digitsNumber = (value, size) => {
  let s = String(value)

  if (typeof size !== 'number') {
    size = 2
  }
  while (s.length < size) {
    s = '0' + s
  }
  return s
}

/**
 * Возвращает целое отформатированное цисло с указанной разрядностью в виде массива.
 * @param {number} value Передаваемое значение.
 * @param {number} size Необходимая разрядность числа.
 * @returns {Array} Отформатированное число.
 */
export const digitsNumberArray = (value, size) => {
  const s = digitsNumber(value, size)
  return s.split('')
}
